module.exports = __webpack_public_path__ + "img/rb18.7136edcf.jpeg";